import { DeleteIcon } from '@chakra-ui/icons';
import { CanvaIcon } from '@/features/canva/components/CanvaIcon';
import type { DecoratedIntegration } from '@/pages/Schedule/hooks/useIntegrations';
import {
  Flex,
  Icon,
  IconButton,
  ListIcon,
  ListItem,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@/ui';
import { useDisconnectDialog } from './DisconnectDialog';

type ItemProps = {
  integration: DecoratedIntegration;
};

export const IntegrationItem = ({ integration }: ItemProps) => {
  const { open: openDisconnectDialog } = useDisconnectDialog();

  return (
    <ListItem>
      <Flex align="center" fontWeight="normal" key={integration.id}>
        <ListIcon as={CanvaIcon} />

        <Text as="span" flexGrow="1">
          {integration.name}
        </Text>

        <Flex align="center" gap="2" justify="flex-start">
          <Menu isLazy placement="bottom-end">
            <MenuButton
              aria-label="Options"
              as={IconButton}
              colorScheme="dark"
              h="5"
              icon={<Icon icon="MoreHorizontal" />}
              variant="unstyled"
            />

            <MenuList>
              <MenuItem
                icon={<DeleteIcon />}
                onClick={() => openDisconnectDialog(integration)}
              >
                Disconnect
              </MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </Flex>
    </ListItem>
  );
};
